import { Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import { BaseStationInspectionDto } from "@/dto/inspection/BaseStationInspectionDto.ts";
import { InspectionRapidStationDto } from "@/dto/inspection/rapid/InspectionRapidStationDto.ts";
import { InspectionRapidChargerDto } from "@/dto/inspection/rapid/InspectionRapidChargerDto.ts";

/**
 * 완속 충전소 보고서 작성 - req
 */
export class RapidInspectionReqDto extends BaseStationInspectionDto {
    @ValidateNested()
    @Type(() => InspectionRapidStationDto)
    inspectionRapidStationDto: InspectionRapidStationDto;

    @ValidateNested({ each: true })
    @Type(() => InspectionRapidChargerDto)
    inspectionRapidChargerList: InspectionRapidChargerDto[];

    constructor() {
        super();
        this.inspectionRapidStationDto = new InspectionRapidStationDto();
        this.inspectionRapidChargerList = [];
    }
}
